:host a {
  display: block;
}
